export default {
  startSelling: '立即入驻',
  growth: '南亚增长最快的电商平台',
  introduce: 'Kilimall 平台介绍',
  process: '入驻流程',
  step1: '注册认证',
  step2: '平台审核',
  step3: '创建店铺',
  step4: '发布商品',
  // 新版招商首页 旧版部分文案暂不删除 以防翻译资源已经被复用引发问题
  bannerTitle: '助力国货出海-赢在非洲',
  bannerSubtitle: '政府认定中非经贸数字平台',
  registerNow: '立即入驻',
  market: '全球最后一片蓝海市场',
  consumer: '13亿潜在电商消费者',
  internet: '4.5亿',
  internetUser: '互联网用户',
  dollars: '750亿',
  dollarsShare: '美金市场份额',
  marketIntroduce: '从2013年开始，移动互联网在非洲飞速发展，互联网用户呈喷井式增长；预计到2025年，非洲的电子商务市场将达到750亿美元市场份额。',
  platform: '最大非洲B2C出口平台',
  monthlySales: '月销售额30万卖家数年增长',
  rate: '复购率',
  orderAmount: '平均客单价',
  development: `Kilimall 发展速度已超越了众多同类网站，现在的 Kilimall 已成为了非洲消费者信赖和喜爱的购物渠道，
  是在非洲民众中颇具影响力的生活和工作服务平台。`,
  advantage: 'Kilimall的优势',
  advantageTitle1: '一带一路国家授权平台',
  advantageTitle2: 'FBK物流模式',
  advantageTitle3: '遍布全非的 KiliShop',
  advantageContent1: '中非经贸博览会官方数字经贸平台授权，国家唯一对非贸易合作平台。响应国家一带一路政策号召，一起共创中非美好生活',
  advantageContent2: '非洲最先进的物流体系，最快可实现当日达。可以让你提前备货到100000平米的海外仓。',
  advantageContent3: '10000+ KiliShop站点全非布局，解决最后一公里物流，堪比国内某网驿站。同时还拥有线上线下社区属性，最大程度的提升下单率。',
  join: '仅需四步，轻松拓金非洲',
  registerTitle1: '注册认证',
  registerTitle2: '平台审核',
  registerTitle3: '创建店铺',
  registerTitle4: '发布商品',
  registerText1: '注册账号以及注册资料',
  registerText2: '等待平台工作人员审核',
  registerText3: '设置店铺名以及登录账号',
  registerText4: '开店成功，进入后台发布商品',
  bottomTitle: '快来抢占非洲最后一片蓝海市场',
  platformTitle: 'Kilimall 非洲领先跨境电商平台',
  more: '了解 Kilimall',
  Kenya: '肯尼亚站点',
  sellerCenter: '卖家中心',
  helpCenter: '帮助中心',
  joinUs: '加入我们',
  trade: '中非经贸博览会',
  website: '官网：www.kilimall.com.cn',
  phone: '联系电话：400-961-8893（周一 - 周五)',
  email: '卖家支持邮箱：seller.support@kilimall.com',
  copyright: '©2022 Kilimall 长沙非拓信息技术有限公司 版权所有',
  copyrightCode: '(c) 2022 Kilimall 湘 ICP No. 19002592号-1'
}
